<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="30%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="warn-info">
      <i class="iconfont iconjinggao"></i>
      <div v-html="warnInfo"></div>
    </div>
    <el-form :model="formData" :rules="formRules" ref="form" label-position="left" label-width="70px">
      <el-form-item label="备注:" prop="remark" class="remark">
        <div class="content">
          <el-input type="textarea" v-model="formData.remark" placeholder="请填写备注" class="form-input"></el-input>
        </div>
      </el-form-item>
      <el-form-item label-width="0px" class="footer">
        <el-button type="primary" @click="submitForm" size="small" :disabled="!disabled">确认</el-button>
        <el-button @click="cancel" size="small">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  data() {
    return {
      title: '修改状态',
      dialogVisible: false,
      warnInfo: '',
      formData: {
        remark: '',
      },
      formRules: {
        remark: [{ required: true, message: '请填写备注', trigger: 'blur' }],
      },
      success: () => {},
    };
  },
  computed: {
    disabled() {
      return Boolean(this.formData.remark);
    },
  },
  methods: {
    submitForm() {
      this.success(this.formData);
      this.cancel();
    },
    cancel() {
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
// 重写 element-ui 样式
/deep/.el-dialog__body {
  padding-bottom: 0;
  padding-top: 10px;
}
.warn-info {
  .flex_layout(row, flex-start, center);
  .iconfont {
    color: #ff9f07;
    margin-right: 0.5em;
    margin-left: 0.4em;
  }
  /deep/p {
    margin: 0;
    font-size: @base-font-size;
  }
}
.footer {
  .flex_layout(row, flex-end, flex-end);
  padding-bottom: 1em;
  margin-bottom: 0;
}
.remark {
  margin-top: 1em;
}
</style>
